import { IStore } from '../index'

export const getStatsYear = (state: IStore) => state.stats.year
export const getStatsMonth = (state: IStore) => state.stats.month
export const getStatsChartsType = (state: IStore) => state.stats.chartType
export const getStatsSelectedRooms = (state: IStore) =>
  state.stats.selectedRooms

export const getStatsReservation = (state: IStore) => state.stats.reservation
export const getStatsOccupancy = (state: IStore) => state.stats.occupancy
export const getStatsAvgPrice = (state: IStore) => state.stats.avgPrice
export const getStatsRevPAR = (state: IStore) => state.stats.RevPAR
